// Page_Institution_Documentacion
//
// Formacion del portal de la INSTITUCION REVI (/portal/inst/documentacion).
// Reutiliza la misma pagina que el terapeuta cambiando la audiencia: cada
// perfil ve el material que el admin le ha marcado como suyo desde
// /admin/revi?tab=formacion.

import React from "react";
import { useTranslation } from "react-i18next";
import { Page_Therapist_Documentacion } from "../../Page_therapist/Page_Therapist_Documentacion/Page_Therapist_Documentacion";

// Los nombres Page_* son la convencion del codebase; ESLint avisa de
// jsx-pascal-case igual que en el resto de paginas del proyecto.
/* eslint-disable react/jsx-pascal-case */
export function Page_Institution_Documentacion() {
  // Los rotulos viajan como props a la pagina del terapeuta: se traducen aqui,
  // que es donde se decide la audiencia.
  const { t } = useTranslation("institution");

  return (
    <Page_Therapist_Documentacion
      audience="institution"
      title={t("documentation.title")}
      subtitle={t("documentation.subtitle")}
      infoTitle={t("documentation.infoTitle")}
    />
  );
}
/* eslint-enable react/jsx-pascal-case */
